/*----- Core -----*/
import React           from 'react'
import styled, { css } from 'styled-components'
import PropTypes 			 from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color from '../../commons/Color'

/*----- Styles -----*/
const StyledParagraph = styled.p`
	${ Montserrat(16, 500, Color.grey ) };
	max-width: 600px;
	margin: 16px 0 16px 0;
	${props => props.bold && css`
		font-weight: 600;
  `}
`

/*----- Component -----*/
const Paragraph = ({ content, bold }) => (
	<StyledParagraph className="custom-paragraph" bold={bold}>{ content }</StyledParagraph>
)
export default Paragraph

/*----- PropTypes -----*/
Paragraph.propTypes = {
  content: PropTypes.any.isRequired,
  bold:		 PropTypes.bool,
}
